import { createI18n } from 'vue-i18n'
import zhTW from './locales/zh-TW'
import zhCN from './locales/zh-CN'

const i18n = createI18n({
  legacy: false,
  locale: 'zh-TW', // 默认繁体中文
  fallbackLocale: 'zh-TW',
  messages: {
    'zh-TW': zhTW,
    'zh-CN': zhCN
  }
})

export default i18n
